module.exports = __webpack_public_path__ + "img/pic07.91e4c17b.jpg";